import { type ModalOpenResult, useModalStore } from '@tix/modal'

import HtmlModalContent from '@/components/HtmlModalContent.vue'
import BundleInformation, { type BundleInformationProps } from '@/components/bundles/BundleInformation.vue'

export function openDescriptionModal(description: string): ModalOpenResult {
  return useModalStore().open({
    component: HtmlModalContent,
    name: 'bundle-description',
    title: 'About this event',
    // TODO What size should this be?
    size: 'md',
    props: { html: description },
  })
}

export function openBundleDetailsModal(details: Omit<BundleInformationProps, 'mode'>): ModalOpenResult {
  return useModalStore().open({
    component: BundleInformation,
    name: 'bundle-details',
    size: 'xl',
    props: { ...details, mode: 'modal' },
    closeable: false,
    actions: [
      {
        label: 'Done',
        onAction: (close) => close(),
      },
    ],
  })
}
